import { StepCardPaper, AccentBorder, StepText, StepTextBottom } from './styles';
import NumberPill from '../NumberPill';

const StepCard = ({ id, titleTop, titleBottom, layout = 'textTop', accent }) => {
  return (
    <StepCardPaper elevation={0}>
      <AccentBorder accent={accent} />

      {layout === 'textTop' ? (
        <>
          <StepText>{titleTop}</StepText>
          <NumberPill id={id} />
        </>
      ) : (
        <>
          <NumberPill id={id} />
          <StepTextBottom>{titleBottom}</StepTextBottom>
        </>
      )}
    </StepCardPaper>
  );
};

export default StepCard;
